import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  searchWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 12,
    borderBottom: '1px solid #e9e9e9',
    paddingBlockStart: 20,
    paddingBlockEnd: 12,
  },
  title: {
    '& .MuiTypography-root': {
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        fontSize: 15,
      },
    },
  },
  clearAll: {
    '& .MuiTypography-root': {
      textDecoration: 'underline',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        fontSize: 15,
      },
    },
  },
  sortByWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 12,
    paddingBlock: 12,
    borderBottom: '1px solid #e9e9e9',
  },
  sortByLabel: {
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  sortByFilter: {
    width: 240,
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBlock: 20,
  },
  categoryFilter: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
  },
  filterHeader: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      textTransform: 'uppercase',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
  },
  filterItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  subCategoryWrapper: {
    '& .MuiTypography-root': {
      paddingBlock: 4,
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.custom.main,
        fontWeight: 600,
      },
    },
  },
  productsContainer: {
    paddingInline: 20,
    [theme.breakpoints.down('sm')]: {
      paddingInline: 0,
    },
  },
  productsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  productSpacing: {
    paddingInline: 20,
    paddingBlock: 20,
    [theme.breakpoints.down('lg')]: {
      paddingInline: 12,
      paddingBlock: 12,
    },
    // [theme.breakpoints.down('md')]: {
    //   paddingInline: 12,
    //   paddingBlock: ,
    // },
  },
  productCard: {
    boxShadow: '3px 4px 13px #ccc',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    maxHeight: '100%',
    overflow: 'hidden',
    // [theme.breakpoints.down('sm')]: {
    //   minHeight: 244,
    // },
  },
  imgWrapper: {
    // width: '100%',
    // height: 264,
    // cursor: 'pointer',
    // [theme.breakpoints.down('sm')]: {
    //   height: 160,
    // },

    position: 'relative',
    backgroundColor: '#fff',
  },
  productImg: {
    // width: '100%',
    // height: '100%',

    width: '100%',
    height: 'auto',
    aspectRatio: 1 / 1,
    maxHeight: '100%',
    overflow: 'hidden',
  },
  productDetail: {
    paddingBlock: 12,
    borderTop: '1px solid #e9e9e9',
    textAlign: 'center',
  },
  productLabel: {
    display: 'flex',
    gap: 8,
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingInline: 8,
    [theme.breakpoints.down('sm')]: {
      paddingInline: 12,
    },
  },
  discount: {
    color: '#b8292f',
    fontWeight: 600,
  },
  pagination: {
    paddingBlockStart: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noDataWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingBlockStart: 20,
    '& .MuiTypography-root': {
      textAlign: 'center',
      paddingBlock: 12,
      paddingInline: 12,
    },
  },
  notFoundImg: {
    width: 120,
    height: 120,
  },
}))

export default useStyles
